module.exports = __webpack_public_path__ + "img/bgc22.22ec2234.png";